import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { DataprivacyComponent } from './dataprivacy/dataprivacy.component';
import { ImpressumComponent } from './impressum/impressum.component';
import { LetterComponent } from './letter/letter.component';

const routes: Routes = [
  { path: 'impressum', component: ImpressumComponent },
  { path: 'datenschutz', component: DataprivacyComponent },
  { path: '**', component: LetterComponent },
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled', // Restores scroll position when navigating back
  anchorScrolling: 'enabled', // Enables fragment-based scrolling
  scrollOffset: [0, 64],
  enableTracing: false
}
@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
